import React from 'react'
import file from '../../../../Global/assets/CRDCopper.mp4'

const Crd_Copper = () =>{
    return(
        <>
            <div id="ExperimentsB" style={{height:'110vh'}}>
                <div style={{width:'80%', height:'50%'}}>
                    <video src={file} width='100%' height='100%' controls></video>
                </div>
                <div style={{width:'80%', height:'30vh', color:'#fff'}}>
                        <h1>Action of Lemon on Corroded Copper</h1><br />
                        <h4>Observations : </h4><br />
                        <h6>1. The Corroded Copper is Actually : Copper Oxide</h6><br />
                        <h6>2. Upon the reaction of the Corroded with the Lemon the green coating of the copper oxide dissapperas and the new shiny copper is obtained.</h6> <br />
                        <h6>3. A Neutrilisation Reaction takes place in this case as the Copper Oxide is Basic in nature and the Citric Acid is acidic in nature.</h6>
                </div>
            </div>
        </>
    )
}

export { Crd_Copper }